module.exports = __webpack_public_path__ + "img/ic-bag-in-the-box.3cde1418.svg";